import React, { FC } from 'react'
import { Box, Grid, Image } from '@components/gassan-ui'
import { Heading, Text } from '@rolex-ui'
import { AssetsElement } from '@lib/kontent/models/Elements'
import { getKontentImage } from '@lib/kontent'
import { rem } from 'polished'

type Props = {
  variant: 'image-text' | 'text-image'
  image: AssetsElement
  title: string
  description: string
}

const KeyModelFeature: FC<Props> = ({ variant, image, title, description }) => {
  return (
    <Grid
      ml={{ _: '5vw', large: variant === 'image-text' ? '5vw' : 'initial' }}
      mr={{ _: '5vw', large: variant === 'text-image' ? '5vw' : 'initial' }}
      gridTemplateColumns={{
        _: '1fr',
        large: variant === 'image-text' ? '45vw 50vw' : '50vw 45vw'
      }}
      gridColumnGap="0"
      gridRowGap="1.25rem"
      alignItems="center"
      mt="5vw"
    >
      <Box gridColumn={{ large: variant === 'text-image' ? 2 : 1 }} gridRow={{ large: 1 }}>
        <Image
          ratio={1}
          sources={[
            getKontentImage(image?.value[0]?.url, { width: 600 }),
            getKontentImage(image?.value[0]?.url, { width: 600 }),
            getKontentImage(image?.value[0]?.url, { width: 750 })
          ]}
          placeholderSrc={getKontentImage(image?.value[0]?.url, { width: 50 })}
          alt={image?.value[0]?.description}
        />
      </Box>
      <Box
        px={{ large: '10vw' }}
        gridColumn={{ large: variant === 'text-image' ? 1 : 2 }}
        gridRow={{ _: 2, large: 1 }}
      >
        <Heading variant="mediumTitle" mb={rem(10)}>
          {title}
        </Heading>
        <Text style={{ whiteSpace: 'pre-line' }}>{description}</Text>
      </Box>
    </Grid>
  )
}

export default KeyModelFeature
